export default function Photos() {
  function picture(activ) {
    return (
      <div className="vid">
        <a href="https://img.youtube.com/vi/bXIXxrrr4l4/hqdefault.jpg">
          {activ ? (
            <img
              className="activ"
              src="https://img.youtube.com/vi/bXIXxrrr4l4/hqdefault.jpg"
              alt=""
            />
          ) : (
            <img
              src="https://img.youtube.com/vi/bXIXxrrr4l4/hqdefault.jpg"
              alt=""
            />
          )}
        </a>
        <br />
        <a href="https://img.youtube.com/vi/bXIXxrrr4l4/hqdefault.jpg">
          Deogratius Interview
        </a>
      </div>
    );
  }
  return (
    <div className="galary">
      {picture()}
      {picture(true)}
      {picture()}
    </div>
  );
}
